module.exports = __webpack_public_path__ + "./Miao_56ab80bc4e3c1a6647fc2bed71875c9d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2020/Miao.jpg
// module id = 498
// module chunks = 0